import React from 'react';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import PromoBanner from '../components/PromoBanner';
import SEO from '../components/SEO';
import { seoData } from '../data/seoData';

const PrivacyPolicyPage = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <SEO {...seoData.privacy} />
      <PromoBanner />
      <Navigation />
      
      {/* Header */}
      <section className="pt-20 pb-16 bg-white">
        <div className="container">
          <div className="text-center max-w-3xl mx-auto">
            <h1 className="display-hero text-gray-900 mb-6">
              Privacy Policy
            </h1>
            <p className="body-large text-gray-600">
              Your privacy is important to us. This privacy policy explains how we collect, use, and protect your information.
            </p>
          </div>
        </div>
      </section>

      {/* Content */}
      <section className="py-20">
        <div className="container">
          <div className="max-w-4xl mx-auto">
            <div className="bg-white rounded-xl shadow-sm p-8 md:p-12 border border-gray-100">
              <div className="prose prose-lg max-w-none">
                <h2>Information We Collect</h2>
                <p>We collect information you provide directly to us, such as when you create or modify your account, request on-demand services, contact us for support, or otherwise communicate with us.</p>
                
                <h2>How We Use Your Information</h2>
                <p>We use the information we collect to provide, maintain, and improve our services, process transactions, send you technical notices and support messages, and communicate with you about products, services, offers, and events.</p>
                
                <h2>Information Sharing and Disclosure</h2>
                <p>We do not sell, trade, or otherwise transfer your personal information to outside parties except as described in this policy.</p>
                
                <h2>Data Security</h2>
                <p>We implement appropriate security measures to protect against unauthorized access, alteration, disclosure, or destruction of your personal information.</p>
                
                <h2>Your Choices</h2>
                <p>You may decline to submit personal information, in which case we may not be able to provide certain services to you.</p>
                
                <h2>Changes to This Policy</h2>
                <p>We may update this privacy policy from time to time. We will notify you of any changes by posting the new privacy policy on this page.</p>
                
                <h2>Contact Us</h2>
                <p>If you have any questions about this privacy policy, please contact us.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      <Footer />
    </div>
  );
};

export default PrivacyPolicyPage;